export default __webpack_public_path__ + "static/Cover-1cb41be051f2480e700323f3fa304136.png";